/* lp3 — comportements de la fiche produit (galerie, onglets, lots, questions,
   paiement, compte à rebours d'expédition). Vanilla JS, aucune dépendance sauf Swiper. */
(function () {
  'use strict';

  function whenSwiper(cb, tries) {
    if (window.Swiper) return cb();
    if ((tries || 0) > 100) return;
    setTimeout(function () { whenSwiper(cb, (tries || 0) + 1); }, 50);
  }

  function initGallery(root) {
    var main = root.querySelector('.mainSwiper');
    if (!main) return;
    whenSwiper(function () {
      if (main.swiper) main.swiper.destroy(true, true);
      var thumbs = root.querySelectorAll('.lp3-thumb');
      var sw = new Swiper(main, {
        speed: 500, rewind: true,
        breakpoints: { 0: { slidesPerView: 1.07, spaceBetween: 8 }, 768: { slidesPerView: 1, spaceBetween: 10 } }
      });
      var prev = root.querySelector('.lp3-arrow--prev'), next = root.querySelector('.lp3-arrow--next');
      if (prev) prev.addEventListener('click', function () { sw.slidePrev(); });
      if (next) next.addEventListener('click', function () { sw.slideNext(); });
      function mark(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        var t = thumbs[i], box = t && t.parentElement;
        if (!t || !box) return;
        if (box.scrollHeight > box.clientHeight) box.scrollTo({ top: t.offsetTop - box.offsetTop - (box.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
        else if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: t.offsetLeft - box.offsetLeft - (box.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { sw.slideTo(parseInt(t.getAttribute('data-index'), 10) || 0); }); });
      sw.on('slideChange', function () { mark(sw.activeIndex); });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('.feature_tab-col').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var card = tab.closest('.feature_card');
        card.querySelectorAll('.feature_tab-col').forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
        card.querySelectorAll('.feature_tab-panel').forEach(function (p) { p.hidden = true; });
        tab.classList.add('active'); tab.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
        if (root.__lp3Rev) root.__lp3Rev.update();
      });
    });
  }

  function renderIncluded(root, card) {
    var row = root.querySelector('.included_row');
    var tpl = card && card.querySelector('template.qs-included');
    if (!row || !tpl) return;
    row.innerHTML = tpl.innerHTML;
    row.style.display = row.children.length ? '' : 'none';
  }

  // Récapitulatif « ยอดรวม » sous le choix de paiement (copie ErgoLab) : nom du produit + lot, prix barré, prix.
  function updateTotal(root, card) {
    var t = root.querySelector('.pco-real-total'); if (!t) return;
    var q = card.querySelector('.qs-qty'), s = card.querySelector('.qs-strike'), p = card.querySelector('.qs-price');
    t.querySelector('.pco-real-total-name').textContent = (t.getAttribute('data-product') || '') + (q && q.textContent.trim() ? ' - ' + q.textContent.trim() : '');
    var S = t.querySelector('s'), B = t.querySelector('b');
    S.textContent = s ? s.textContent.trim() : ''; S.style.display = S.textContent ? '' : 'none'; B.textContent = p ? p.textContent.trim() : '';
    root.__pcoTotalBase = { strike: S.textContent, price: B.textContent };
  }
  function setTotal(root, strike, price) {
    var t = root.querySelector('.pco-real-total'); if (!t) return;
    var S = t.querySelector('s'), B = t.querySelector('b'); S.textContent = strike || ''; S.style.display = strike ? '' : 'none'; B.textContent = price || '';
  }
  function initBundles(root) {
    var cards = root.querySelectorAll('.qs-card');
    var form = root.querySelector('.pdp-atc-form');
    function select(card) {
      cards.forEach(function (c) { c.classList.remove('sel'); });
      card.classList.add('sel');
      if (form) {
        form.querySelector('[data-lp3="variant"]').value = card.getAttribute('data-variant');
        form.querySelector('[data-lp3="qty"]').value = card.getAttribute('data-qty-cart') || 1;
      }
      renderIncluded(root, card); updateTotal(root, card);
      try { root.dispatchEvent(new CustomEvent('pco:offer-change')); } catch (e) {}
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    var first = root.querySelector('.qs-card.sel') || cards[0];
    if (first) select(first);
  }

  function slide(el, open) {
    if (open) {
      el.style.display = 'block'; var h = el.scrollHeight; el.style.height = '0px';
      requestAnimationFrame(function () { el.style.transition = 'height .4s'; el.style.height = h + 'px'; });
      setTimeout(function () { el.style.height = ''; el.style.transition = ''; }, 420);
    } else {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(function () { el.style.transition = 'height .4s'; el.style.height = '0px'; });
      setTimeout(function () { el.style.display = 'none'; el.style.height = ''; el.style.transition = ''; }, 420);
    }
  }

  function initQuestions(root) {
    root.querySelectorAll('.hero_question_heading').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = q.nextElementSibling, isOpen = q.classList.contains('open');
        root.querySelectorAll('.hero_question_heading.open').forEach(function (o) {
          if (o !== q) { o.classList.remove('open'); slide(o.nextElementSibling, false); }
        });
        q.classList.toggle('open', !isOpen); slide(a, !isOpen);
      });
    });
  }

  function initRating(root) {
    var link = root.querySelector('.rated_text'), box = root.querySelector('.pop-rating_box');
    if (!link || !box) return;
    if (window.matchMedia('(max-width: 767px)').matches) {
      link.addEventListener('click', function (e) { if (!e.target.closest('.pop-rating_box')) box.style.display = box.style.display === 'block' ? 'none' : 'block'; });
      document.addEventListener('click', function (e) { if (!e.target.closest('.rated_text')) box.style.display = 'none'; });
    } else {
      link.addEventListener('mouseenter', function () { box.style.display = 'block'; });
      link.addEventListener('mouseleave', function () { box.style.display = 'none'; });
    }
  }

  function initShipping(root) {
    var box = root.querySelector('.shipping-calculate-date');
    if (!box) return;
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 14;
    var months = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    function bkk() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Bangkok', hour12: false })); }
    function fmt(d) { return d.getDate() + ' ' + months[d.getMonth()]; }
    function tick() {
      var now = bkk(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
      var d0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()), d1 = new Date(d0.getTime() + 864e5);
      box.querySelectorAll('.pdp-date-0').forEach(function (e) { e.textContent = fmt(d0); });
      box.querySelectorAll('.pdp-date-1').forEach(function (e) { e.textContent = fmt(d1); });
      var target = now < today ? today : new Date(today.getTime() + 864e5), dist = target - now;
      var txt = Math.floor(dist / 36e5) + ' ชม. ' + Math.floor(dist % 36e5 / 6e4) + ' นาที ' + Math.floor(dist % 6e4 / 1e3) + ' วินาที';
      var t = box.querySelector('.shipping__message--today'), m = box.querySelector('.shipping__message--tomorrow');
      if (now < today) { t.style.display = 'block'; m.style.display = 'none'; t.querySelector('.remain-time').textContent = txt; }
      else { t.style.display = 'none'; m.style.display = 'block'; m.querySelector('.within-time').textContent = txt; }
    }
    tick(); setInterval(tick, 1000);
  }

  function initPayment(root) {
    var block = root.querySelector('.pco-real-payment');
    var btn = root.querySelector('.pco-cta-btn');
    if (!block || !btn) return;
    var label = btn.querySelector('.pco-cta-label');
    var labels = { choose: btn.getAttribute('data-label-choose'), confirm: btn.getAttribute('data-label-confirm') };
    var inner = block.querySelector('.pco-real-form'), note = block.querySelector('.pco-real-note'), msg = block.querySelector('.pco-real-msg');
    var methods = block.querySelectorAll('.pco-real-method-btn'), chosen = null;
    var required = ['name', 'phone', 'address', 'zip'].map(function (k) { return block.querySelector('[data-field="' + k + '"]'); });
    function valid() { return required.every(function (f) { return f && f.value.trim().length > 0; }); }
    function render() {
      if (!chosen) { label.textContent = labels.choose; btn.classList.add('pco-real-disabled'); return; }
      label.textContent = labels.confirm; btn.classList.toggle('pco-real-disabled', !valid());
    }
    methods.forEach(function (m) {
      m.addEventListener('click', function () {
        methods.forEach(function (x) { x.classList.remove('sel'); }); m.classList.add('sel');
        chosen = m.getAttribute('data-method'); inner.style.display = ''; var tot = block.querySelector('.pco-real-total'); if (tot) tot.style.display = '';
        var n = m.getAttribute('data-note') || '';
        note.textContent = n; note.style.display = n ? '' : 'none';
        render();
      });
    });
    required.forEach(function (f) { if (f) f.addEventListener('input', render); });
    render();

    // case assurance (bump)
    var addon = root.querySelector('.pco-real-addon');
    if (addon) {
      var check = addon.querySelector('.pco-real-addon-check');
      var offerChanged = function () { try { root.dispatchEvent(new CustomEvent('pco:offer-change')); } catch (e) {} };
      addon.addEventListener('click', function (e) { if (e.target === check) return; e.preventDefault(); check.checked = !check.checked; addon.classList.toggle('sel', check.checked); offerChanged(); });
      check.addEventListener('change', function () { addon.classList.toggle('sel', check.checked); offerChanged(); });
    }

    // Envoi (copie du tunnel ErgoLab) : on bloque Shopify, on écrit la session dans le navigateur,
    // on réserve côté serveur sans attendre, et on part vers l'upsell. La commande est créée sur la page de confirmation.
    function token() { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'pco-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10); }
    function phone(raw) { var d = (raw || '').replace(/\D/g, ''); if (d.indexOf('66') === 0 && d.length > 9) d = d.slice(2); d = d.replace(/^0+/, ''); return d ? '+66' + d : ''; }
    function field(k) { var f = block.querySelector('[data-field="' + k + '"]'); return f ? f.value.trim() : ''; }
    function utms() {
      var out = {}, q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'ttclid', 'gclid', 'gbraid', 'wbraid', 'campaign_id', 'ad_id', 'adset_id'].forEach(function (k) { if (q.get(k)) out[k] = q.get(k); });
      try { var saved = JSON.parse(sessionStorage.getItem('pco_landing') || 'null'); if (saved) Object.keys(saved).forEach(function (k) { if (!out[k]) out[k] = saved[k]; }); } catch (e) {}
      // Référent externe + page d'arrivée (26/10) : posés par le layout à la première page de la session ; sans UTM ni clic, google.com = SEO.
      try { var ref = JSON.parse(sessionStorage.getItem('pco_ref') || 'null'); if (ref) { out.referrer = ref.referrer; out.landing_page = ref.landing_page; } } catch (e) {}
      out.full_url = (function () { try { return JSON.parse(sessionStorage.getItem('pco_landing') || '{}').full_url || location.href; } catch (e) { return location.href; } })();
      return out;
    }
    try { if (!sessionStorage.getItem('pco_landing')) {
      // Arrivée par une autre page du site (accueil, menu) : les UTM sont dans l'URL de la page précédente.
      var u0 = utms(), land = location.href, ref = null;
      try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) {}
      if (ref && ref.host === location.host && /[?&](utm_|fbclid|ttclid|gclid|gbraid|wbraid|ad_id)/.test(ref.search)) {
        new URLSearchParams(ref.search).forEach(function (v, k) { if (/^(utm_source|utm_medium|utm_campaign|utm_content|utm_term|utm_id|fbclid|ttclid|gclid|gbraid|wbraid|campaign_id|ad_id|adset_id)$/.test(k) && v && !u0[k]) u0[k] = v; });
        land = ref.href;
      }
      u0.full_url = land; sessionStorage.setItem('pco_landing', JSON.stringify(u0)); } } catch (e) {}

    // Panier Shopify (10/10) : WeTracked relie son visiteur (clic pub, fbp, IP, navigateur) au jeton du panier et
    // écrit ses identifiants dans les attributs du panier (vid, auid, fbp…). Notre formulaire ne passe pas par le
    // panier : on recopie le jeton et ces attributs sur la commande, comme le faisait EasySell. Sinon WeTracked
    // n'envoie à Meta que les données client de la commande, sans le clic.
    var cartInfo = null;
    function loadCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartInfo = c; }).catch(function () {}); }
    setTimeout(loadCart, 3000);
    block.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.pco-real-method-btn')) loadCart(); });
    function cartAttrs() {
      var out = {}, a = (cartInfo && cartInfo.attributes) || {};
      Object.keys(a).slice(0, 30).forEach(function (k) { if (/^[\w\-]{1,64}$/.test(k) && typeof a[k] === 'string' && a[k]) out[k] = a[k].slice(0, 500); });
      if (cartInfo && cartInfo.token) out['shopify-cart-token'] = cartInfo.token;
      return out;
    }

    var form = root.querySelector('.pdp-atc-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!valid() || !chosen) return;
      var endpoint = (block.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
      if (!endpoint) { msg.textContent = block.getAttribute('data-not-ready'); msg.hidden = false; return; }
      var ERR = { bad_phone: block.getAttribute('data-phone-error') || 'กรุณากรอกเบอร์มือถือ 10 หลัก', bad_name: 'กรุณากรอกชื่อ-นามสกุลผู้รับ', bad_address: 'กรุณากรอกที่อยู่จัดส่งให้ครบ ต้องมีบ้านเลขที่ ถนน/หมู่ ตำบล/แขวง อำเภอ/เขต', bad_zip: 'กรุณากรอกรหัสไปรษณีย์ 5 หลัก' };
      function showErr(code, focusKey) { msg.textContent = ERR[code] || ERR.bad_address; msg.hidden = false; btn.classList.remove('pco-real-disabled'); var f = focusKey && block.querySelector('[data-field="' + focusKey + '"]'); if (f) { f.classList.add('pco-real-invalid'); f.focus(); } }
      required.forEach(function (f) { if (f) f.classList.remove('pco-real-invalid'); });
      var ph = phone(field('phone'));
      if (field('name').length < 2) { showErr('bad_name', 'name'); return; }
      if (ph.length !== 12) { showErr('bad_phone', 'phone'); return; }
      if (field('address').length < 8 || !/\d/.test(field('address'))) { showErr('bad_address', 'address'); return; }
      if (field('zip').replace(/\D/g, '').length !== 5) { showErr('bad_zip', 'zip'); return; }
      msg.hidden = true;
      var email = field('email'); if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) email = '';
      var variant = form.querySelector('[data-lp3="variant"]').value, qty = parseInt(form.querySelector('[data-lp3="qty"]').value, 10) || 1;
      var addons = [];
      if (addon && addon.querySelector('.pco-real-addon-check').checked) addons.push({ variantId: addon.getAttribute('data-variant-id'), qty: 1 });
      var session = {
        token: token(), reserveUrl: endpoint + '/reserve-cod-order', submitUrl: endpoint + '/submit-cod-order',
        bases: [{ variantId: variant, quantity: qty, productTitle: block.getAttribute('data-product-title') || '', image: block.getAttribute('data-product-image') || '' }],
        addons: addons, upsells: [], paymentMethod: chosen,
        customer: { fullName: field('name'), phone: ph, email: email, address: field('address'), zip: field('zip').replace(/\D/g, '') },
        cartAttributes: Object.assign(cartAttrs(), utms(), { pco_source: block.getAttribute('data-source') || '' }), /* pdp-v1 chien / pdp-cat chat : le Worker tague la commande */ upsellVariant: Math.random() < 0.5 ? 'A' : 'B', test: block.getAttribute('data-test') === 'true', pageUrl: location.href, createdAt: Date.now(),
        promoCode: root.__pcoPromo || ''
      };
      try { sessionStorage.setItem('pco_session_v1', JSON.stringify(session)); } catch (err) {}
      btn.classList.add('pco-real-disabled');
      var next = block.getAttribute('data-upsell-url') || '/pages/cod-order-upsell-1', gone = false;
      function go() { if (gone) return; gone = true; window.location.href = next; }
      // Réservation : on l'attend 2,5 s max. Erreur de saisie renvoyée par le serveur = on reste et on l'affiche ;
      // réseau lent ou en panne = on continue quand même (la commande se crée sur la page de confirmation).
      var cookie = function (n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; };
      var lines = session.bases.map(function (b) { return { variantId: b.variantId, quantity: b.quantity, role: 'base' }; }).concat(addons.map(function (a) { return { variantId: a.variantId, quantity: a.qty, role: 'addon' }; }));
      var timer = setTimeout(go, 2500);
      fetch(session.reserveUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify({ cartToken: session.token, paymentMethod: chosen, lineItems: lines, customer: session.customer, cartAttributes: session.cartAttributes, upsellVariant: session.upsellVariant, promoCode: session.promoCode, test: session.test, fbp: cookie('_fbp'), fbc: cookie('_fbc'), pageUrl: location.href }) })
        .then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
        .then(function (r) {
          if (r.status === 400 && r.d && /^bad_(name|phone|address|zip)$/.test(r.d.error || '')) { clearTimeout(timer); try { sessionStorage.removeItem('pco_session_v1'); } catch (e) {} showErr(r.d.error, r.d.error.replace('bad_', '')); return; }
          clearTimeout(timer); go();
        })
        .catch(function () { clearTimeout(timer); go(); });
    });
  }

  // ---- Code promo (10/10/2026) : n'importe quel code créé dans Shopify > Remises. Le serveur de commande le
  // vérifie et calcule le prix ; ici on n'affiche que sa réponse. Pré-rempli par ?discount=CODE ou /discount/CODE.
  function initPromo(root) {
    var box = root.querySelector('.pco-promo'), pay = root.querySelector('.pco-real-payment'), form = root.querySelector('.pdp-atc-form');
    if (!box || !pay || !form) return;
    var endpoint = (pay.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    var q = function (c) { return box.querySelector(c); };
    var toggle = q('.pco-promo-toggle'), panel = q('.pco-promo-box'), input = q('.pco-promo-input'), apply = q('.pco-promo-apply'),
        msg = q('.pco-promo-msg'), ok = q('.pco-promo-ok'), okText = q('.pco-promo-ok-text'), okTotal = q('.pco-promo-ok-total'), remove = q('.pco-promo-remove'),
        okNote = q('.pco-promo-ok-note');
    var ERR = {
      not_found: 'ไม่พบโค้ดนี้ กรุณาตรวจสอบอีกครั้ง', expired: 'โค้ดนี้หมดอายุหรือยังไม่เริ่มใช้งาน', used_up: 'โค้ดนี้ถูกใช้ครบจำนวนแล้ว',
      not_applicable: 'โค้ดนี้ใช้กับสินค้านี้ไม่ได้', unsupported: 'โค้ดนี้ใช้กับการสั่งซื้อนี้ไม่ได้', customer_only: 'โค้ดนี้สำหรับลูกค้าเฉพาะกลุ่ม',
      min_subtotal: 'โค้ดนี้ใช้ได้เมื่อสั่งซื้อขั้นต่ำ {x}', min_qty: 'โค้ดนี้ใช้ได้เมื่อสั่งซื้อตั้งแต่ {x} ขวดขึ้นไป',
      lookup_failed: 'ตรวจสอบโค้ดไม่ได้ในขณะนี้ กรุณาลองอีกครั้ง'
    };
    var baht = function (n) { return '฿' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 }); };
    var cookie = function (n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; };
    function lines() {
      var l = [{ variantId: form.querySelector('[data-lp3="variant"]').value, quantity: parseInt(form.querySelector('[data-lp3="qty"]').value, 10) || 1, role: 'base' }];
      var a = root.querySelector('.pco-real-addon');
      if (a && a.querySelector('.pco-real-addon-check').checked) l.push({ variantId: a.getAttribute('data-variant-id'), quantity: 1, role: 'addon' });
      return l;
    }
    function err(code, detail) {
      var t = ERR[code] || ERR.not_found;
      msg.textContent = t.replace('{x}', code === 'min_subtotal' ? baht(detail) : (detail || '')); msg.hidden = false;
    }
    function openBox() { toggle.hidden = true; panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    var last = '';
    function applied(r) {
      root.__pcoPromo = r ? r.code : '';
      if (!r) { ok.hidden = true; if (root.__pcoTotalBase) setTotal(root, root.__pcoTotalBase.strike, root.__pcoTotalBase.price); return; }
      setTotal(root, r.totalBefore > r.total ? baht(r.totalBefore) : '', baht(r.total));
      okText.textContent = (r.freeShipping ? box.getAttribute('data-ok-ship') : box.getAttribute('data-ok')).replace('{code}', r.code).replace('{amount}', baht(r.discount));
      var parts = (box.getAttribute('data-total') || '{total}').split('{total}');
      okTotal.textContent = '';
      okTotal.appendChild(document.createTextNode(parts[0] || ''));
      if (r.totalBefore > r.total) { var st = document.createElement('s'); st.textContent = baht(r.totalBefore); okTotal.appendChild(st); okTotal.appendChild(document.createTextNode(' ')); }
      var b = document.createElement('b'); b.textContent = baht(r.total); okTotal.appendChild(b);
      okTotal.appendChild(document.createTextNode(parts[1] || ''));
      // code fidélité nominatif : on prévient qu'il sera vérifié sur le téléphone du titulaire
      if (okNote) { okNote.textContent = box.getAttribute('data-personal') || ''; okNote.hidden = !(r.personal && okNote.textContent); }
      toggle.hidden = true; panel.hidden = true; msg.hidden = true; ok.hidden = false;
    }
    function check(code, quiet) {
      code = String(code || '').trim().replace(/\s+/g, '');
      if (!code || !endpoint) return;
      apply.disabled = true; box.classList.add('is-busy');
      fetch(endpoint + '/promo-preview', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: code, lineItems: lines() }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { last = code; applied(d); return; }
          last = ''; applied(null); openBox(); input.value = code; err(d && d.error, d && d.detail);
        })
        .catch(function () { if (!quiet || last) { applied(null); openBox(); input.value = code; err('lookup_failed'); } last = ''; })
        .then(function () { apply.disabled = false; box.classList.remove('is-busy'); });
    }
    // 14/10 : le navigateur Facebook/Instagram remplit tout seul le champ avec des codes qu'il a trouvés (souvent un
    // code fidélité nominatif d'un autre client) et clique « ใช้โค้ด » à la place du client. On n'écoute plus que les
    // gestes réels (isTrusted) : un code ne compte que s'il a été tapé ou collé par la personne.
    var typed = false;
    ['keydown', 'paste', 'beforeinput', 'input'].forEach(function (t) { input.addEventListener(t, function (e) { if (e.isTrusted) typed = true; }); });
    function applyNow() { msg.hidden = true; if (!typed) { input.value = ''; return; } check(input.value); }
    toggle.addEventListener('click', function (e) { if (!e.isTrusted) return; openBox(); input.focus(); });
    apply.addEventListener('click', function (e) { if (!e.isTrusted) return; applyNow(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (e.isTrusted) applyNow(); } });
    input.addEventListener('input', function (e) { msg.hidden = true; if (!e.isTrusted && !typed) input.value = ''; });
    remove.addEventListener('click', function () { last = ''; applied(null); input.value = ''; toggle.hidden = false; panel.hidden = true; });
    root.addEventListener('pco:offer-change', function () { if (last) check(last, true); });
    var u = new URLSearchParams(location.search);
    var pre = u.get('discount') || u.get('code') || u.get('promo') || u.get('coupon') || cookie('discount_code') || box.getAttribute('data-prefill') || '';
    if (pre) { input.value = pre; check(pre, true); }
  }

  function init(root) {
    if (!root || root.__lp3) return; root.__lp3 = true;
    initGallery(root); initTabs(root); initBundles(root); initQuestions(root);
    initRating(root); initShipping(root); initPayment(root); initPromo(root);
  }
  function initAll() { document.querySelectorAll('.lp3[data-lp3-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.lp3[data-lp3-hero]'); if (r) { r.__lp3 = false; init(r); } });
})();
